import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { DimensionSlug, validDimensionSlug } from '@features/reports';
import { sortNullable } from '@utils/arrays';

export type Subdimension = Lci3Report['subdimensions'][number];

export type SubdimensionsByName = Partial<
  Record<DimensionSlug, Subdimension[]>
>;

export const subdimensionsByName = (subdimensions: Subdimension[]) =>
  subdimensions.reduce((acc, subdimension) => {
    const dimensionSlug = subdimension.name;
    if (!validDimensionSlug(dimensionSlug)) return acc;

    acc[dimensionSlug] = [...(acc[dimensionSlug] ?? []), subdimension];
    return acc;
  }, {} as SubdimensionsByName);

export const sortByVisitLift = (a: Subdimension, b: Subdimension) => {
  return sortNullable(
    a.visitMetrics.incrementalLift ?? null,
    b.visitMetrics.incrementalLift ?? null
  );
};

export const sortBySalesLift = (a: Subdimension, b: Subdimension) => {
  return sortNullable(
    a.salesMetrics?.incrementalSalesLift.total ?? null,
    b.salesMetrics?.incrementalSalesLift.total ?? null
  );
};
